import React from 'react';
import {useTranslation} from 'react-i18next';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import {makeStyles} from '@material-ui/core/styles';

import {ActionButton} from 'components/common';
import IconButton from "@material-ui/core/IconButton/IconButton";
import CloseIcon from "@material-ui/icons/Close";

const useStyles = makeStyles((theme) => ({
    imageModalContainer: {
        '& .MuiDialog-paper': {
            maxWidth: '100%',
            maxHeight: '100%',
            justifyContent: 'center',
            boxShadow: theme.palette.shadow.main,
        },
    },
    imageModalContent: {
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        marginLeft: 'auto',
        marginRight: 'auto',
    },
    title: {
        background: "#004980",
        paddingRight: theme.spacing(2),
        '& h2': {
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            fontSize: 26,
            lineHeight: '30px',
            color: theme.palette.base.white,
            '& .MuiButtonBase-root': {
                color: theme.palette.base.white,
            },
            '& input + fieldset': {
                borderColor: theme.palette.base.white
            },
        },
    },
    attachment: {
        width: '100%',
        objectFit: 'contain',
    },
    actions: {
        marginTop: theme.spacing(5),
        justifyContent: 'center',
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.base.white,
    },
}));

function ImageDetail(props) {
    const classes = useStyles();
    const {t} = useTranslation();

    const {
        opened,
        handleClose,
        image
    } = props;

    const getHostImage = (image) => {
        return <img src={`data:image/png;base64,${image}`} className={classes.attachment} alt=""/>
    }

    return (
        <Dialog
            className={classes.imageModalContainer}
            open={opened}
            onClose={handleClose}
            fullWidth={true}
        >
            <DialogTitle className={classes.title}>
                {t('QR_CODE')}
                <IconButton aria-label="close" className={classes.closeButton} onClick={handleClose}>
                    <CloseIcon/>
                </IconButton>
            </DialogTitle>
            <DialogContent className={classes.imageModalContent} titleStyle={{textAlign: "center"}}>
                {image && getHostImage(image)}
            </DialogContent>
            <DialogActions className={classes.actions}>
                <ActionButton
                    action="closeModal"
                    handleClick={handleClose}
                />
            </DialogActions>
        </Dialog>
    );
}

ImageDetail.propTypes = {
    opened: PropTypes.bool.isRequired,
    image: PropTypes.string,
    handleClose: PropTypes.func.isRequired,
};

ImageDetail.defaultProps = {
    image: null,
};

const mapStateToProps = (store) => ({});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(ImageDetail);
